// extracted by mini-css-extract-plugin
export default {"form":"EditSongForm_form__QSqyz","checkboxLabel":"EditSongForm_checkboxLabel__NndQt","buttonRow":"EditSongForm_buttonRow__651Rw"};